"use client";

import { WishlistFilledIcon } from "@/components/appIcons";
import { useLists } from "@/contexts/lists-context";
import { useHydrated } from "@/hooks/use-hydrated";
import { cn } from "@/lib/utils";

interface WishlistBadgeProps {
  workId?: string | null;
  releaseId?: string | null;
  className?: string;
}

export function WishlistBadge({ workId, releaseId, className }: WishlistBadgeProps) {
  const { isInWishlist } = useLists();
  const hydrated = useHydrated();

  if (!hydrated || !isInWishlist({ workId, releaseId })) {
    return null;
  }

  return (
    <div
      className={cn(
        "absolute top-2 left-2 z-20 size-7 rounded-full bg-red-500 text-white flex items-center justify-center shadow-lg ring-2 ring-white/80",
        className,
      )}
    >
      <WishlistFilledIcon className="text-sm" />
    </div>
  );
}
